import React from 'react';
import HoverEnlargePhoto, {
  ACTIVITY_LOGS_PHOTO_PREVIEW_SIZE,
} from 'pages/components/HoverEnlargePhoto/HoverEnlargePhoto';
import type { ReportContextStanding } from './reportContextUsers';
import * as S from './ReportStaffFacePhoto.styled';

const GCS_IMAGE_BASE = 'https://storage.googleapis.com/images_wiegfbiwudjdvh/';

export const resolveStaffPhotoSrc = (img?: string | null): string => {
  if (!img) return '';
  if (img.startsWith('data:') || img.startsWith('http')) return img;
  return `${GCS_IMAGE_BASE}${img}`;
};

const ReportStaffFacePhoto = ({
  src,
  name,
  size = 22,
  standing,
  onDark,
}: {
  src?: string | null,
  name: string,
  size?: number,
  standing?: ReportContextStanding,
  /** Viewer chrome on a dark bar. */
  onDark?: boolean,
}) => {
  const photoSrc = resolveStaffPhotoSrc(src);
  const initial = String(name || '?').trim().charAt(0).toUpperCase() || '?';
  return (
    <HoverEnlargePhoto
      src={photoSrc}
      previewSize={ACTIVITY_LOGS_PHOTO_PREVIEW_SIZE}
      previewShape="circle"
    >
      {photoSrc ? (
        <S.Thumb src={photoSrc} alt="" $size={size} $onDark={onDark} />
      ) : (
        <S.Fallback
          aria-hidden
          $size={size}
          $standing={standing}
          $onDark={onDark}
        >
          {initial}
        </S.Fallback>
      )}
    </HoverEnlargePhoto>
  );
};

export default ReportStaffFacePhoto;
